
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import CustomerDialog from '@/components/CustomerDialog/levelByLevel.vue';
import DialogSetStaff from '../../staff/components/setStaff.vue';
import { makeKey } from '@/utils/qiniu';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { addProject, editorProject, getProjectDetail } from '@/api/project';

@Component({
  name: 'setShifts',
  components: {
    CustomerDialog,
    DialogSetStaff }
})
export default class extends Vue {
  @Prop({
    type: String,
    default: '100px'
  })
  labelWidth?: String;
  @Prop({
    type: Object,
    default: () => {}
  })
  editData!: any;

  private formProject: any = {
    name: '',
    serial: '',
    customer: '',
    manager: '',
    startTime: '',
    endTime: '',
    related: '',
    desp: '',
    fileEdit: [],
    fileList: []
  }
  private projectAlias=(UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目')

  private staffEnterType=8;

  private customerVisible = false
  private editDataCustomer: any = {}

  private dialogSetStaffVisible = false
  private selectStaffType: number = 1
  private selectStaffArray: any = []
  private selectManagerArray: any = [] // 新建项目 负责人
  private selectRelatedArray: any = [] // 新建项目 关联人员

  // 骑牛
  private qiuniuToken:any={
    action_url: ''
  }
  private qiuniuform:any={}

  private vipLevel:number=3;
  created() {
    if (parseInt(UserModule.getCompanyId) !== 0 && UserModule.company) {
      this.vipLevel = parseInt(
        String(UserModule.company.vip_level).substring(0, 1)
      );
    }
    if (this.vipLevel === 2) {
      this.formProject.customer = {
        id: UserModule.getCompanyId,
        name: UserModule.getCompanyName,
        customer_company_id: UserModule.getCompanyId,
        customer_type: 1
      };
    }
    const params = {
      type: Qiniu.UPLOAD_TYPE_PROJECT
    };
    getQiniuToken(params).then(res => {
      if (res && res.data) {
        this.qiuniuToken = res.data;
      }
    });
    if (this.editData && this.editData.id) {
      this.formProject.name = this.editData.name;
      this.formProject.serial = this.editData.project_number;
      // 项目编号
      if (parseInt(this.editData.customer_type) === 1) {
        this.formProject.customer = {
          id: this.editData.customer_id,
          name: this.editData.customer_name,
          customer_company_id: this.editData.customer_id,
          customer_type: this.editData.customer_type
        };
      } else {
        this.formProject.customer = {
          id: this.editData.customer_id,
          name: this.editData.customer_name,
          customer_user_id: this.editData.customer_id,
          customer_type: this.editData.customer_type
        };
      }
      this.editData.user_list.forEach((element:any) => {
        let manager:any = {};
        manager.id = element.user_id;
        manager.name = element.user_name;
        manager.mobile = element.mobile;
        this.selectManagerArray.push(manager);
      });
      this.editData.relation_user_list.forEach((element:any) => {
        let manager:any = {};
        manager.id = element.user_id;
        manager.name = element.user_name;
        manager.mobile = element.mobile;
        this.selectRelatedArray.push(manager);
      });
      this.formProject.startTime = this.editData.plan_start_date_time + '000';
      this.formProject.endTime = this.editData.plan_end_date_time + '000';
      this.formProject.desp = this.editData.describe;
      this.getProjectDetail(this.editData.id);
    }
  }
  private getProjectDetail(id:any) {
    let _ = this;
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = id;
    getProjectDetail(pamars).then((res:any) => {
      this.formProject.fileEdit = res.data.resources_list;
    });
  }
  private resourceClick(val:any) {
    window.open(val.url);
  }
  beforeRemove(file: any, fileList: any) {
    // return this.$confirm(`确定移除 ${file.name}？`);
  }
  handleRemove(file: any, fileList: any) {
    this.formProject.fileList = fileList;
  }
  handlePreview(file: any) {
  }
  handleExceed(files: any, fileList: any) {
    // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }
  private projectCustomerSelected() {
    this.customerVisible = true;
  }
  private customerClose(val: boolean) {
    this.customerVisible = val;
  }
  private selectedCustomer(val: any) {
    this.formProject.customer = val;
  }
  private formProjectHandle() {
    if (!this.formProject.name) {
      this.showErrorMsg('请输入' + this.projectAlias + '名称');
      return;
    }
    if (!this.formProject.customer || !this.formProject.customer.id) {
      this.showErrorMsg('请选择客户');
      return;
    }
    if (!this.selectManagerArray || this.selectManagerArray.length < 1) {
      this.showErrorMsg('请选择负责人');
      return;
    }
    if (!this.formProject.startTime) {
      this.showErrorMsg('请选择计划开始时间');
      return;
    }
    if (!this.formProject.endTime) {
      this.showErrorMsg('请选择计划结束时间');
      return;
    }
    if (this.formProject.startTime > this.formProject.endTime) {
      this.showErrorMsg('计划开始时间晚于计划结束时间');
      return;
    }
    let fileList:any = [];
    if (this.formProject.fileList) {
      this.formProject.fileList.forEach((element:any) => {
        let fileData:any = {};
        fileData.name = element.raw.name;
        fileData.content = element.response.key;
        if (element.raw.type.includes('image')) {
          fileData.type = 1;
          fileList.push(fileData);
        } else if (element.raw.type.includes('video')) {
          fileData.type = 3;
          fileList.push(fileData);
        } else {
          fileData.type = 4;
          fileList.push(fileData);
        }
      });
    }
    if (this.formProject.fileEdit.length > 0) {
      fileList = fileList.concat(this.formProject.fileEdit);
    }

    let managerList:any = [];
    this.selectManagerArray.forEach((element:any) => {
      let manager:any = {};
      manager.id = element.id;
      manager.name = element.name;
      manager.mobile = element.mobile;
      managerList.push(manager);
    });
    let relatedList:any = [];
    if (this.selectRelatedArray) {
      this.selectRelatedArray.forEach((element:any) => {
        let related:any = {};
        related.id = element.id;
        related.name = element.name;
        related.mobile = element.mobile;
        relatedList.push(related);
      });
    }

    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.name = this.formProject.name;
    pamars.project_number = this.formProject.serial;
    // 项目编号
    if (parseInt(this.formProject.customer.customer_company_id) !== 0) {
      pamars.customer_id = this.formProject.customer.customer_company_id;
    } else {
      pamars.customer_id = this.formProject.customer.customer_user_id;
    }
    pamars.customer_name = this.formProject.customer.name;
    pamars.customer_type = this.formProject.customer.customer_type;

    pamars.plan_start_date_time = parseInt(this.formProject.startTime / 1000 + '') + 86399;
    pamars.plan_end_date_time = parseInt(this.formProject.endTime / 1000 + '') + 86399;
    pamars.describe = this.formProject.desp;

    pamars.manager_users = JSON.stringify(managerList);
    if (relatedList && relatedList.length > 0) {
      pamars.relation_users = JSON.stringify(relatedList);
    }
    if (fileList && fileList.length > 0) {
      pamars.resources = JSON.stringify(fileList);
    }
    if (this.editData && this.editData.id) {
      pamars.project_id = this.editData.id;
      editorProject(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.close();
        this.$emit('finishAdd');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addProject(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.emptyForm();
        this.selectManagerArray = [];
        this.selectRelatedArray = [];
        this.close();
        this.$emit('finishAdd');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private closeFileHandle(val: any) {
    const idx = this.formProject.fileEdit.indexOf(val);
    if (idx > -1) {
      this.formProject.fileEdit.splice(idx, 1);
    }
  }

  private emptyForm() {
    this.formProject = {
      name: '',
      serial: '',
      customer: '',
      manager: '',
      startTime: '',
      endTime: '',
      related: '',
      desp: '',
      fileEdit: [],
      fileList: []
    };
    if (this.vipLevel === 2) {
      this.formProject.customer = {
        id: UserModule.getCompanyId,
        name: UserModule.getCompanyName,
        customer_company_id: UserModule.getCompanyId,
        customer_type: 1
      };
    } else {
      this.formProject.customer = '';
    }
  }

  private managerStaff(val: any) {
    if (this.selectStaffType === 1) {
      this.selectManagerArray = val;
    } else {
      this.selectRelatedArray = val;
    }
  }
  private delManagerHandle(val: any) {
    this.selectManagerArray.splice(this.selectManagerArray.indexOf(val), 1);
  }
  private relatedStaffSelected() {
    this.dialogSetStaffVisible = true;
    this.staffEnterType = 9;
    this.selectStaffType = 2;
    this.selectStaffArray = this.selectRelatedArray;
  }
  private delRelatedHandle(val: any) {
    this.selectRelatedArray.splice(this.selectRelatedArray.indexOf(val), 1);
  }
  private closeStaffHandle(val: any) {
    this.dialogSetStaffVisible = val;
  }
  private managerStaffSelected() {
    this.staffEnterType = 8;
    this.dialogSetStaffVisible = true;
    this.selectStaffType = 1;
    this.selectStaffArray = this.selectManagerArray;
  }
  // qiniu
  private uploadSuccess(res: any, file:any, fileList:any) {
    this.formProject.fileList = fileList;
  }
  private beforeUpload(file:any) {
    // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    // const isLt2M = file.size / 1024 / 1024 < 5;
    // if (!isJPG) {
    //   return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    // }
    // if (!isLt2M) {
    //   return this.$message.error('上传图片大小不能超过 5MB!');
    // }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      if (file.type === 'video/mp4') {
        // this.$set(this.qiuniuform, 'key', makeKey(this.qiuniuToken.prekey) + '.mp4');
        this.$set(this.qiuniuform, 'token', this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, 'domain', this.qiuniuToken.domain);
      } else {
        // this.$set(this.qiuniuform, 'key', makeKey(this.qiuniuToken.prekey));
        this.$set(this.qiuniuform, 'token', this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, 'domain', this.qiuniuToken.domain);
      }
    });
  }

  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
